import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface QuestionnaireAttachmentUploadDialogProps {
  open: boolean;
  fileCount: number;
  onConfirm: () => void;
  onClose: () => void;
}

export function QuestionnaireAttachmentUploadDialog({
  open,
  fileCount,
  onConfirm,
  onClose,
}: QuestionnaireAttachmentUploadDialogProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t("fileAttachments.confirmUploadTitle")}
          </AlertDialogTitle>
          <AlertDialogDescription className="break-words min-w-0 max-w-full">
            {t("fileAttachments.confirmUploadDescription", {
              count: fileCount,
            })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>
            {t("common.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {t("common.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
